export const ROUTE_DEFAULT = "/";
export const ROUTE_LOGIN = "/login";
export const ROUTE_SKILL_LEVELS = "/skillLevels";
export const ROUTE_SKILLS = "/skills";
export const ROUTE_USERS = "/users";
export const ROUTE_AUTH = "/auth";
export const ROUTE_LOGOUT = "/logout";
export const ROUTE_QUEUES = "/queues";
export const ROUTE_QUEUE_MEMBERS = "/queuemembers";
export const ROUTE_QUEUE_ACTIVATION = "/queueactivation";
export const ROUTE_SKILL_GROUPS = "/skillGroups";
export const ROUTE_SKILL_SCHEDULER = "/skillScheduler";
